export default "__VITE_ASSET__cy9T3Cvs__"